interface ReviewFlagIconProps {
  languageCode: string;
}

export default function ReviewFlagIcon({ languageCode }: ReviewFlagIconProps) {
  switch (languageCode) {
    case 'BE':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_524)">
            <path d="M0 0H18V12H0V0Z" fill="#FDDA25" />
            <path d="M0 0H6V12H0V0Z" fill="black" />
            <path d="M12 0H18V12H12V0Z" fill="#EF3340" />
          </g>
          <defs>
            <clipPath id="clip0_11375_524">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'DE':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_532)">
            <path d="M0 -0.000183105H18V12H0V-0.000183105Z" fill="#D80027" />
            <path d="M0 -0.000183105H18V3.99972H0V-0.000183105Z" fill="black" />
            <path d="M0 7.99977H18V11.9997H0V7.99977Z" fill="#FFDA44" />
          </g>
          <defs>
            <clipPath id="clip0_11375_532">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'DA':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_539)">
            <path d="M0 0H18V12H0V0Z" fill="#C60C30" />
            <path
              d="M6.66667 0H4.5614V4.91228H0V7.01754H4.5614V12H6.66667V7.01754H18V4.91228H6.66667V0Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_11375_539">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'FR':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_528)">
            <path d="M0 -0.000106812H18V12H0V-0.000106812Z" fill="white" />
            <path d="M0 -0.000106812H5.99987V12H0V-0.000106812Z" fill="#0052B4" />
            <path d="M12.0001 -7.62939e-05H18V12.0001H12.0001V-7.62939e-05Z" fill="#D80027" />
          </g>
          <defs>
            <clipPath id="clip0_11375_528">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'GB':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_542)">
            <path d="M0 0H18V12.0001H0V0Z" fill="white" />
            <path
              d="M10.125 -0.000152588H7.875V4.87482H0V7.12482H7.875V11.9998H10.125V7.12482H18V4.87482H10.125V-0.000152588Z"
              fill="#D80027"
            />
            <path
              d="M13.844 8.08682L18 10.3957V8.08682H13.844ZM10.9565 8.08682L18 11.9999V10.8933L12.9483 8.08682H10.9565ZM16.1238 11.9999L10.9565 9.12885V11.9999H16.1238Z"
              fill="#0052B4"
            />
            <path d="M10.9565 8.08682L18 11.9999V10.8933L12.9483 8.08682H10.9565Z" fill="white" />
            <path d="M10.9565 8.08682L18 11.9999V10.8933L12.9483 8.08682H10.9565Z" fill="#D80027" />
            <path
              d="M3.17605 8.08675L0 9.85124V8.08675H3.17605ZM7.04348 8.58435V11.9998H0.896168L7.04348 8.58435Z"
              fill="#0052B4"
            />
            <path d="M5.05171 8.08682L0 10.8933V11.9999L7.04348 8.08682H5.05171Z" fill="#D80027" />
            <path
              d="M4.156 3.91288L0 1.60396V3.91288H4.156ZM7.04348 3.91288L0 -0.000152588V1.10636L5.05171 3.91288H7.04348ZM1.87615 -0.000152588L7.04348 2.87085V-0.000152588H1.87615Z"
              fill="#0052B4"
            />
            <path d="M7.04348 3.91288L0 -0.000152588V1.10636L5.05171 3.91288H7.04348Z" fill="white" />
            <path d="M7.04348 3.91288L0 -0.000152588V1.10636L5.05171 3.91288H7.04348Z" fill="#D80027" />
            <path
              d="M14.8239 3.91299L18 2.1485V3.91299H14.8239ZM10.9565 3.41539V-7.62939e-05H17.1038L10.9565 3.41539Z"
              fill="#0052B4"
            />
            <path d="M12.9483 3.91292L18 1.1064V-0.000106812L10.9565 3.91292H12.9483Z" fill="#D80027" />
          </g>
          <defs>
            <clipPath id="clip0_11375_542">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'NL':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_520)">
            <path d="M0 4H18V8H0V4Z" fill="white" />
            <path d="M0 0H18V4H0V0Z" fill="#CD1F2A" />
            <path d="M0 8H18V12H0V8Z" fill="#1D4185" />
          </g>
          <defs>
            <clipPath id="clip0_11375_520">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'NO':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_516)">
            <path d="M0 0.000137329H18V12.0003H0V0.000137329Z" fill="#D80027" />
            <path
              d="M18 7.40198H7.10842V11.9998H4.30436V7.40198H0V4.59749H4.30436V-0.000320435H7.10842V4.59749H18V6.74969V7.40198Z"
              fill="white"
            />
            <path
              d="M18 5.24981V6.74969H6.45652V11.9998H4.95626V6.74969H0V5.24981H4.95626V-0.000320435H6.45652V5.24981H18Z"
              fill="#2E52B2"
            />
          </g>
          <defs>
            <clipPath id="clip0_11375_516">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'SV':
      return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_11375_536)">
            <path d="M0 0H18V12.0001H0V0Z" fill="#0052B4" />
            <path
              d="M6.75 -0.000259399H4.5V4.87472H0V7.12472H4.5V11.9997H6.75V7.12472H18V4.87472H6.75V-0.000259399Z"
              fill="#FFDA44"
            />
          </g>
          <defs>
            <clipPath id="clip0_11375_536">
              <rect width="18" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null; // Return null for unsupported language codes
  }
}
